module.exports = __webpack_public_path__ + "img/safari.bb651ce9.png";